import { render } from "./ModalAlert.vue?vue&type=template&id=cd27622a&ts=true"
import script from "./ModalAlert.vue?vue&type=script&lang=ts"
export * from "./ModalAlert.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__